/**
 * 生徒用画面のルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import RootView from '../views/student/RootView.vue'
import TopPage from '../views/student/TopPage.vue'
import LearningMap from '../views/student/LearningMap.vue'
import ReviewBox from '../views/student/ReviewBox.vue'
import SelectReviewProblem from '../views/student/SelectReviewProblem.vue'
import GeneralStudy from '../views/student/GeneralStudy.vue'
import SeminarStudy from '../views/student/SeminarStudy.vue'
import EntranceStudy from '../views/student/EntranceStudy.vue'
import NoticeList from '../views/student/NoticeList.vue'
import NoticeMessage from '../views/student/NoticeMessage.vue'
import StudentLogin from '../views/student/StudentLogin.vue'
import StudentForceChangePassword from '../views/student/StudentForceChangePassword.vue'
import SelectGeneralProblemCurriculumUnit from '../views/student/SelectGeneralProblemCurriculumUnit.vue'
import SelectSeminarProblemCurriculumUnit from '../views/student/SelectSeminarProblemCurriculumUnit.vue'
import ZnCurriculumUnitConvert from '../views/student/ZnCurriculumUnitConvert.vue'
import GeneralProblemHistory from '../views/student/GeneralProblemHistory.vue'
// 演習系ページ群
import GeneralAutoSelect from '../views/student/study/general/GeneralAutoSelect.vue'
import GeneralProblem from '../views/student/study/general/GeneralProblem.vue'
import GeneralResult from '../views/student/study/general/GeneralResult.vue'
import ReviewProblem from '../views/student/study/review/ReviewProblem.vue'
import ReviewResult from '../views/student/study/review/ReviewResult.vue'
// パスワードリセット系ページ群
import StudentPasswordReminder from '../views/student/password/StudentPasswordReminder.vue'
import StudentPasswordReminderComplete from '../views/student/password/StudentPasswordReminderComplete.vue'
import StudentPasswordReset from '../views/student/password/StudentPasswordReset.vue'
import StudentPasswordResetComplete from '../views/student/password/StudentPasswordResetComplete.vue'
import StudentPasswordResetTimeout from '../views/student/password/StudentPasswordResetTimeout.vue'
// メールアドレス更新系ページ群
import ReconfigureMailUpdate from '../views/student/ReconfigureMailUpdate.vue'
import ReconfigureMailTokenInvalid from '../views/student/ReconfigureMailTokenInvalid.vue'
import ReconfigureMailComplete from '../views/student/ReconfigureMailComplete.vue'

/**
 * 生徒用ページ群
 */
const studentRoutes: Array<RouteConfig> = [
  // ルートアクセス時のリダイレクト処理
  {
    path: '/student',
    name: 'StudentRoot',
    component: RootView,
  },
  // ログイン
  {
    path: '/student/login',
    name: 'StudentLogin',
    component: StudentLogin,
  },
  // 初回パスワード変更
  {
    path: '/student/password',
    name: 'StudentPassword',
    component: StudentForceChangePassword,
  },
  // トップページ
  {
    path: '/student/top',
    name: 'StudentTop',
    component: TopPage,
  },
  // 知識MAP
  {
    path: '/student/map',
    name: 'StudentLearningMap',
    component: LearningMap,
  },
  // 復習BOX
  {
    path: '/student/review',
    name: 'StudentReviewBox',
    component: ReviewBox,
  },
  // 単元別復習問題選択
  {
    path: '/student/review/:curriculumUnitId',
    name: 'StudentReviewProblem',
    component: SelectReviewProblem,
  },
  // 通常授業サポート学習
  {
    path: '/student/general',
    name: 'StudentGeneral',
    component: GeneralStudy,
  },
  // 講習会トレーニング
  {
    path: '/student/seminar',
    name: 'StudentSeminar',
    component: SeminarStudy,
  },
  // 入試直前トレーニング
  {
    path: '/student/entrance',
    name: 'StudentEntrance',
    component: EntranceStudy,
  },
  // お知らせページ
  {
    path: '/student/notice',
    name: 'StudentNoticeList',
    component: NoticeList,
  },
  // お知らせメッセージ
  {
    path: '/student/notice/:id',
    name: 'StudentNotice',
    component: NoticeMessage,
  },
  // 通常授業サポート単元別問題選択
  {
    path: '/student/general/:curriculumUnitId',
    name: 'StudentGeneralProblem',
    component: SelectGeneralProblemCurriculumUnit,
  },
  // 講習会トレーニング単元別問題選択
  {
    path: '/student/seminar/:curriculumUnitId',
    name: 'StudentSeminarProblem',
    component: SelectSeminarProblemCurriculumUnit,
  },
  // 増進堂単元から単元を選択
  {
    path: '/student/map/:znCurriculumUnitId',
    name: 'StudentLearningmapUnit',
    component: ZnCurriculumUnitConvert,
  },
  // 通常授業サポート学習問題演習履歴一覧
  {
    path: '/student/general/history/:learningId',
    name: 'StudentGeneralProblemHistory',
    component: GeneralProblemHistory,
  },
  // === 演習系ページ群
  // 演習実施-通常学習、進行度が進む演習
  {
    path: '/student/general/study/auto/:curriculumUnitId',
    name: 'StudentStudyGeneralAuto',
    component: GeneralAutoSelect,
  },
  // 演習実施-通常学習、問題指定(進行度に影響がない学習)
  {
    path: '/student/general/study/:fixedExerciseId/:problemId',
    name: 'StudentStudyGeneralProblem',
    component: GeneralProblem,
  },
  // 演習結果-通常学習
  {
    path: '/student/general/result/:learningId',
    name: 'StudentStudyGeneralResult',
    component: GeneralResult,
  },
  // 演習実施-復習BOX
  {
    path: '/student/review/study/:fixedExerciseId/:problemId',
    name: 'StudentStudyReviewProblem',
    component: ReviewProblem,
  },
  // 演習結果-復習BOX
  {
    path: '/student/review/result/:learningId',
    name: 'StudentStudyReviewResult',
    component: ReviewResult,
  },
  // パスワードリマインダ
  {
    path: '/student/password/reminder',
    name: 'StudentPasswordReminder',
    component: StudentPasswordReminder,
  },
  // パスワードリマインダ(送信完了)
  {
    path: '/student/password/reminder/complete',
    name: 'StudentPasswordReminderComplete',
    component: StudentPasswordReminderComplete,
  },
  // パスワードリマインダ(再設定)
  {
    path: '/student/password/reset',
    name: 'StudentPasswordReset',
    component: StudentPasswordReset,
  },
  // パスワードリマインダ(再設定完了)
  {
    path: '/student/password/reset/complete',
    name: 'StudentPasswordResetComplete',
    component: StudentPasswordResetComplete,
  },
  // パスワードリマインダ(トークン無効)
  {
    path: '/student/password/reset/error',
    name: 'StudentPasswordResetTimeout',
    component: StudentPasswordResetTimeout,
  },
  // メールアドレス更新：認証メールからの遷移先クッションページ
  {
    path: '/student/reconfigureMail',
    name: 'StudentReconfigureMail',
    component: ReconfigureMailUpdate,
  },
  // メールアドレス更新：認証エラーページ
  {
    path: '/student/reconfigureMail/invalid',
    name: 'StudentReconfigureMailInvalid',
    component: ReconfigureMailTokenInvalid,
  },
  // メールアドレス更新：完了ページ
  {
    path: '/student/reconfigureMail/complete',
    name: 'StudentReconfigureMailComplete',
    component: ReconfigureMailComplete,
  },
]

export default studentRoutes
